import { render, staticRenderFns } from "./ModalViewAddress.vue?vue&type=template&id=0f7c39f4"
import script from "./ModalViewAddress.vue?vue&type=script&lang=js"
export * from "./ModalViewAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports